import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '@web/components/Toggle';
import {DownArrowOutlined} from '@web/assets/icons';
import UserAvatar from '@web/components/UserAvatar';
import Icon from '@web/components/Icon';
import {Button, List, Tag} from 'antd';

WorkflowServicesListItem.propTypes = {
  service: PropTypes.object,
  onSelect: PropTypes.func,
};

function WorkflowServicesListItem(props) {
  const [active, setActive] = React.useState(false);

  return props.service.children?.length ?
    <List.Item>
      <Toggle
        trigger={
          <div className="space space-col">
            <h2 className="capitalize space space-center-y space-between" style={{width: "100%", marginBottom: 0}}>
              <span>{props.service.label}</span>
              <Button ghost size="small" className="icon-btn icon-left">
                <DownArrowOutlined />
              </Button>
            </h2>
            <span className="muted">
              {props.service?.description}
            </span>
          </div>
        }>
        <div className="space space-col" style={{marginTop: "20px"}}>
          {props.service.children?.map((service) => {
            return <List.Item
              key={service.method}
              onClick={() => setActive(true)}
              extra={
                active ?
                  <Button
                    className={active ? "green-color" : ""}
                    onClick={() => props.onSelect(service)}
                    shape="round"
                  >Add This</Button> :
                  <Tag>{service.type}</Tag>
              }
            >
              <List.Item.Meta
                title={
                  <div className="space space-center-y">
                    {service.logo ? <UserAvatar icon={service.icon ? <Icon name={service.icon} /> : null} photoURL={service?.logo} /> : <Icon name={service.icon} />}
                    <h2 className="capitalize">
                      {service.label || service.method.split(":")[1]}
                    </h2>
                  </div>
                }
                description={<span className="">{service?.description}</span>}
              />
            </List.Item>;
          })}
        </div>
      </Toggle>
    </List.Item> :
    <List.Item
      onClick={() => setActive(true)}
      extra={
        active ?
          <Button className={active ? "green-color" : ""} onClick={() => props.onSelect(props.service)} shape="round">Add This</Button> :
          <Tag>{props.service.type}</Tag>
      }
    >
      <List.Item.Meta
        title={
          <div className="space space-center-y">
            {props.service.logo ? <UserAvatar icon={props.service.icon ? <Icon name={props.service.icon} /> : null} photoURL={props.service?.logo} /> : <Icon name={props.service.icon} />}
            <h2 className="capitalize">
              {props.service.label || props.service.method.split(":")[1]}
            </h2>
          </div>
        }
        description={<span className="">{props.service?.description}</span>}
      />
      {/*<List.Item.Meta*/}
      {/*  title={<div className="space space-center-y"><Icon name={props.service.icon} /><h2 className="capitalize">{props.service.method?.split?.(":")?.[1]}</h2></div>}*/}
      {/*  description={<span className="">{props.service?.description}</span>}*/}
      {/*/>*/}
    </List.Item>;
}

export default WorkflowServicesListItem;
